<template>
 <div>
     <v-tabs>
                <v-tab
                        v-for="link in links"
                        :key="link"
                        text
                        @click="view = link"
                >
                    {{ link }}
                </v-tab>

     </v-tabs>
     <v-spacer></v-spacer>
     <v-card-text>
         <p style="color:blue;cursor:pointer;" class="pt-4" @click="$emit('backToSearch')"><v-icon>mdi-arrow-left</v-icon> Back to search</p>
     </v-card-text>
     <v-card-title>
         Selected User: {{user.partnerId}}</v-card-title>
     <user-details v-if="view === 'Details'" :user="user"></user-details>
     <user-badges v-else-if="view === 'Badges'" :user="user"></user-badges>
     <user-steps v-else-if="view === 'Steps'" :user="user"></user-steps>
 </div>
</template>


<script>
    import UserBadges from './UserBadges'
    import UserSteps from "./UserSteps";
    import UserDetails from "./UserDetails";

    export default {
        components: {UserDetails, UserBadges, UserSteps},
        data: () => ({
            links: [
                'Details',
                'Badges',
                'Steps',
            ],
            view: 'Details'
        }),
        props: ['user'],
        methods: {
        }
    }
</script>
